var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomicilio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00dbdc;\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #04808f;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.38,
    cy: 15.52,
    r: 11.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,20.32l4.95-4.84c1.32-1.32,2.05-3.08,2.05-4.95s-.73-3.63-2.05-4.95c-1.32-1.32-3.08-2.05-4.95-2.05s-3.63,.73-4.95,2.05c-2.73,2.73-2.73,7.17,0,9.9l4.95,4.84h0ZM10.76,6.28c1.13-1.13,2.64-1.76,4.24-1.76s3.11,.62,4.24,1.76c1.13,1.13,1.76,2.64,1.76,4.24s-.62,3.11-1.75,4.24l-4.25,4.15-4.24-4.15c-2.34-2.34-2.34-6.15,0-8.48h0Zm4.24,7.22c1.65,0,2.99-1.34,2.99-2.99s-1.34-2.99-2.99-2.99-2.99,1.34-2.99,2.99,1.34,2.99,2.99,2.99Zm0-4.98c1.1,0,1.99,.89,1.99,1.99s-.89,1.99-1.99,1.99-1.99-.89-1.99-1.99,.89-1.99,1.99-1.99Zm11.94,11.85l-11.94,7.17L3.06,20.37l5.66-3.4h0l.78,.77-4.5,2.63,10,6,10-6-4.48-2.65,.76-.74,5.67,3.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomicilio);
export default __webpack_public_path__ + "static/media/Domicilio.9c1a76eee2241ab2af3d1ffa22f95fdc.svg";
export { ForwardRef as ReactComponent };